function isDayBefore(d1: Date, d2: Date) {
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  return d1 < d2;
}

export function isSameDay(d1: Date | undefined, d2: Date | undefined) {
  if (!d1 || !d2) return Boolean(d1) === Boolean(d2);

  // We copy the dates so setHours doesn't mutate the date
  const d1Copy = new Date(d1.getTime());
  const d2Copy = new Date(d2.getTime());
  d1Copy.setHours(0, 0, 0, 0);
  d2Copy.setHours(0, 0, 0, 0);

  return d1Copy.getTime() === d2Copy.getTime();
}

/**
 * Update a date range of (from, to) with a newly selected newDay value
 * @param newDay The newly selected date
 * @param from The currently selected From
 * @param to The currently selected To
 */
export function calculateNextRange(
  newDay: Date,
  from: Date | undefined,
  to: Date | undefined
) {
  if (!from) {
    // First date set
    return {
      from: newDay,
      to: newDay,
    };
  } else if (to && isSameDay(from, to) && isSameDay(newDay, from)) {
    // Clear if clicking on same day twice
    return {
      from: undefined,
      to: undefined,
    };
  } else if (to && isSameDay(from, to)) {
    // Has single date selected twice and clicked outside
    if (isDayBefore(newDay, from)) {
      // Selected an earlier date so use it as from
      return {
        from: newDay,
        to: from,
      };
    } else {
      // Selected a later date to use it as to
      return {
        from,
        to: newDay,
      };
    }
  } else if (!to && isDayBefore(newDay, from)) {
    // Has initial date and clicked earlier date
    return {
      from: newDay,
      to: from,
    };
  } else if (to) {
    // Has range and clicked date so clear range and use new date
    return { from: newDay, to: newDay };
  } else {
    // Only has from
    return { from, to: newDay };
  }
}
